export default __webpack_public_path__ + "static/profile_compressed-dfc2072b791bbce0d7c0479bf8fa4cd7.webm";